import { ImageMime } from './utils/imageTypes';

export const LOGGER_NAME = 'studio-templates';

export const DEFAULT_IMAGE_FILTER = 'q_90,usm_0.60_1.00_0.01';

export const DEFAULT_IMAGE_TYPES: ImageMime[] = [
  ImageMime.WEBP,
  ImageMime.JPEG,
];

export const TEMPLATES_PER_PAGE = 24;

export const NON_SUPPORTED_LANGUAGES = [
  'tr',
  'ko',
  'it',
  'nl',
  'pl',
  'da',
  'ru',
  'no',
  'sv',
  'cs',
  'th',
  'zh',
  'uk',
  'vi',
  'id',
  'hi',
];
